export const environment = {
  production: false,
  apiUrl: 'https://sky-dap-uat-finance-fa-cognos.azurewebsites.net/api', /*Function app Api URL*/
  functionKey: 'IyvyFm3t7D6kQfF6nPaYF62q9dzW20PEf8TmcGjtnbiVAzFuwRHSog==',
  appUrl: 'https://uat.cognos-controller-archive.middleware.sky' /*Angular Web app URL*/
};
